// removed by extract-text-webpack-plugin
module.exports = {"topContent":"src-page-components-cookie-policy----styles-module---topContent---ye_NQ","content":"src-page-components-cookie-policy----styles-module---content---2OqM_"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/cookie-policy/styles.module.css
// module id = 644
// module chunks = 105951629423537